export default __webpack_public_path__ + "static/media/jsport365_receipt.ca67016a.jpg";